/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(".SizeSwatch__Radio").on("change", function () {

  const sizeMessageElement = document.getElementById('pleaseselectsize');
  sizeMessageElement.innerText = "Select your size:";

  let hurry = document.getElementById("instock-note");
  let hurryQuantity = this.getAttribute("data-v-instock");
  let hurrySpan = document.getElementById("instock-v-quantity");
  if (hurry) {
  hurrySpan.innerHTML = hurryQuantity;
  if (hurryQuantity > 5) {
    hurry.style.display = "none";
  } else if (hurryQuantity == 1) {
    hurry.style.color = "rgb(185,0,0)";
    hurry.style.display = "block";
  } else {
    hurry.style.color = "rgb(225,100,20)";
    hurry.style.display = "block";
  }
  }
  $("#atc--container select [value='" + this.value + "']").prop("selected", true);
  window.selected = true;
  stickButton()
});

$(".block-button.newsletter").click(function (e) {
  $(".popup-minimised").click();
});

$(".popup-minimised, .NewsletterPopup__Hide, #altpopupclose").click(function () {
  if ($(".NewsletterPopup").attr("aria-hidden") == "false") {
    $(".NewsletterPopup").attr("aria-hidden", "true");
    $(".popup-minimised").fadeIn();
  } else {
    $(".NewsletterPopup").attr("aria-hidden", "false");
    $(".popup-minimised").fadeOut();
  }
});

$(".CollectionToolbar__Item--sort").click(function (e) {
  $("#collection-sort-popover").attr("aria-hidden", "false");
});

$(".Popover__Close").click(function (e) {
  $("#collection-sort-popover").attr("aria-hidden", "true");
});

function wishlistcartupdate() {
  var wishlist = $(".CartItemWrapper .iWishAddColl");
  var wishlength = wishlist.length;

  jQuery(".Cart__ItemList .iWishAddColl").each(function () {
    var productid = $(this).data("product").toString();
    var productvarid = $(this).data("variant").toString();

    // if (isInWishlist(productid, productvarid)) {
    //   $(this).replaceWith(
    //     '<a class="iWishAddColl iwishcheck" href="#" data-variant="' +
    //       productvarid +
    //       '" data-product="' +
    //       productid +
    //       '" data-pTitle="' +
    //       productid +
    //       '"><svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16" height="16" viewBox="0 0 16 16"><path fill="#1b1b1b" d="M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"></path></svg></a>'
    //   );
    // } else {
    //   $(this).replaceWith(
    //     '<a class="iWishAddColl" href="#" data-variant="' +
    //       productvarid +
    //       '" data-product="' +
    //       productid +
    //       '" data-ptitle="' +
    //       productid +
    //       '"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="21px" height="21px" viewBox="0 0 378.94 378.94" style="enable-background:new 0 0 378.94 378.94;" xml:space="preserve"><g><path d="M348.151,54.514c-19.883-19.884-46.315-30.826-74.435-30.826c-28.124,0-54.559,10.942-74.449,30.826l-9.798,9.8l-9.798-9.8c-19.884-19.884-46.325-30.826-74.443-30.826c-28.117,0-54.56,10.942-74.442,30.826c-41.049,41.053-41.049,107.848,0,148.885l147.09,147.091c2.405,2.414,5.399,3.892,8.527,4.461c1.049,0.207,2.104,0.303,3.161,0.303c4.161,0,8.329-1.587,11.498-4.764l147.09-147.091C389.203,162.362,389.203,95.567,348.151,54.514z M325.155,180.404L189.47,316.091L53.782,180.404c-28.368-28.364-28.368-74.514,0-102.893c13.741-13.739,32.017-21.296,51.446-21.296c19.431,0,37.702,7.557,51.438,21.296l21.305,21.312c6.107,6.098,16.897,6.098,23.003,0l21.297-21.312c13.737-13.739,32.009-21.296,51.446-21.296c19.431,0,37.701,7.557,51.438,21.296C353.526,105.89,353.526,152.039,325.155,180.404z"></path></g></svg></a>'
    //   );
    // }
  });
}

function changeSize(id) {
  var select = $("select[data-id=" + id + "]")[0];
  var selectBox = select;
  console.log(selectBox);
  var selectedValue = selectBox.options[selectBox.selectedIndex].value;
  CartJS.removeItemById(id);

  CartJS.addItem(selectedValue, {
    success: function (data, textStatus, jqXHR) {},
  });

  console.log("Removing " + id + " and adding " + selectedValue + ".");
}

document.addEventListener("product:added", function (event) {
  dataLayer.push({ event: "atc" });
  console.log(event.detail);
});

if ($(".Slideshow__Carousel")[0]) {
  var $carousel = $(".Slideshow__Carousel").flickity();

  var flkty = $(".Slideshow__Carousel").data("flickity");
  let hideGender = localStorage.getItem("gender_hidden");

  if(hideGender == 'mens') {
    $carousel.flickity("selectCell", ".womens-slide");
  } else if(hideGender == 'womens') {
    $carousel.flickity("selectCell", ".mens-slide");
  }
}

$("#ometria-newsletter-popup .input-group-btn").click(function () {
  var country = $("#country").find(":selected").val();
  console.log(country);
  $("#ometria-newsletter-popup #newsletter-phone-field").val(libphonenumber.parsePhoneNumber($("#newsletter-phone-field").val(), country).number);
});

$(document).on("cart.requestComplete", function (event, cart) {
  document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
  refreshcart();
  console.log("Gym King: Added to cart");
  updateFreeDelivery(cart.total_price);
});

function updateFreeDelivery(total) {
  const target = document.getElementById("free-del-check");
  if (target) {
    if (total > 12499) {
      target.innerHTML = "You've unlocked <b>Free UK Express Delivery</b>";
    } else if (total > 7499 && !window.customer.isMember) {
      target.innerHTML = "<b>You've unlocked Free UK Standard Delivery</b><br>Spend over £125 for Free UK Express Delivery";
    } else if (!window.customer.isMember ) {
      target.innerHTML = "FREE UK Standard Delivery over £75<br>FREE UK Express Delivery over £125";
    }
  }
}

setTimeout(function () {
  if (document.querySelector("#attentive_overlay")) {
    document.querySelector("#attentive_overlay").style.removeProperty("z-index");
  }

  $("[data-contentblockside]").click(function () {
    var gender = $(event.target)[0].closest("[data-contentblockside]").getAttribute("data-gender");
    var content = 'Sidebar Navigation Content Spot: "' + $(event.target)[0].closest("[data-contentblockside]").querySelector(".bottom-left-black").innerText + '"';

    console.log("Gym King: " + gender + " " + content + " Clicked");
    ga("send", "event", "Mobile Navigation Content Spot", "Click", gender, content);
  });

  $("[data-navcontent]").click(function () {
    var gender = $(event.target)[0].closest("[data-navcontent]").getAttribute("data-gender");
    var content = 'Desktop Navigation Content Spot: "' + $(event.target)[0].closest("[data-navcontent]").querySelector(".bottom-left-black").innerText + '"';
    ga("send", "event", "Desktop Navigation Content Spot", "Click", gender, content);

    console.log(gender + ", " + content);
  });

  $(".collection-contentblock").click(function () {
    event.preventDefault();

    var t = $(this).attr("data-gender");

    if (t == "Mens") {
      ga("send", "event", "PLP Content Spot", "Click", "Content Spot - Mens");
      console.log("Gym King: Content Spot Clicked");
    }

    if (t == "Womens") {
      ga("send", "event", "PLP Content Spot", "Click", "Content Spot - Womens");
      console.log("Gym King: Content Spot Clicked");
    }

    window.location.href = $(this).attr("href");
  });
}, 500);

$("#altpopupclose").click(function () {
  $(".NewsletterPopup__Close").click();
});

$("#altpopupclose").click(function () {
  $(".NewsletterPopup__Close").click();
});

function slideshowalt(x) {
  if (x.matches) {
    // If media query matches
    var $carousel = $(" #section-slideshow-alt .Slideshow__Carousel");
    var $carousel = $(" #section-slideshow-alt .Slideshow__Carousel").flickity({
      setGallerySize: true,
    });
    $carousel.flickity("resize");
  } else {
    var $carousel = $(" #section-slideshow-alt .Slideshow__Carousel");
    var $carousel = $(" #section-slideshow-alt .Slideshow__Carousel").flickity({
      setGallerySize: false,
    });
    $carousel.flickity("resize");
  }
}

var x = window.matchMedia("(max-width: 700px)");
slideshowalt(x); // Call listener function at run time
x.addListener(slideshowalt); // Attach listener function on state changes
wishlistcartupdate();

$(".Header__Wrapper #drawerbtn").click(function () {
  wishlistcartupdate();
});

$(".btnsidebarmenu[href]").click(function () {
  var gender;
  var menu;
  var item = $(this)[0].innerText;
  var build;

  if ($(this).parents(".SidebarMenu__Nav").hasClass("submenu")) {
    menu = $(this).parent().parent().find(".boldfontblack")[0].innerText + " > ";
  } else {
    menu = "";
  }

  if ($(".mensmenu-div").is(":visible")) {
    gender = "Mens";
  } else {
    gender = "Womens";
  }

  build = gender + " > " + menu + item;

  gtag("event", "mobile_menu", { item: build });
});

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = document.querySelector("#predictive-search");

    this.input.addEventListener(
      "input",
      this.debounce((event) => {
        this.onChange(event);
      }, 300).bind(this)
    );
  }

  onChange() {
    const searchTerm = this.input.value.trim();
    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[limit]=8&resources[limit_scope]=each&resources[type]=product,page,collection,article,query&resources[options][fields]=body,product_type,title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {

        gtag("event", "view_search_results"), { search_term: searchTerm, send_to: "G-5VYXHDTFF7" };

        const resultsMarkup = new DOMParser().parseFromString(text, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
        let predictivecarousel = document.querySelector(".predictive-search__products");
            var flkty = new Flickity(predictivecarousel, {
              cellAlign: "center",
              contain: true,
              wrapAround: true,
              prevNextButtons: false,
              pageDots: false,
              imagesLoaded: true,
              watchCSS: true,
            });
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = "block";
  }

  close() {
    this.predictiveSearchResults.style.display = "none";
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define("predictive-search", PredictiveSearch);

function submitSearch(element) {
  if (isEmpty(document.querySelector("#searchPage__input").value)) {
    return false;
  }

  element.closest("form").submit();
  return false;
}

function isEmpty(str) {
  return !str.trim().length;
}

document.addEventListener("DOMContentLoaded", function () {
  let hideGender = localStorage.getItem("gender_hidden");
  hideGender == "mens" ? document.getElementById("womens-button-sidemenu").click() : document.getElementById("mens-button-sidemenu").click();


  if (window.theme.country != "GB") {
    $(".ge-hide").css({ "display": "none", "height": "0" });
  }
});

document.addEventListener('keydown', function(e) {
  if (((e.metaKey || e.ctrlKey) && e.key == "/" && document.activeElement.tagName == "BODY") || ((e.metaKey || e.ctrlKey) && e.key == "/" && document.activeElement.id == "Search")) {
    e.preventDefault();
    document.getElementById("search--btn").click();
  }

    if ((e.metaKey || e.ctrlKey) && e.key == "b" && document.activeElement.tagName == "BODY") {
      e.preventDefault();
      let cart = document.getElementById("sidebar-cart")
      cart.getAttribute("aria-hidden") == "true" ? document.getElementById("drawerbtn").click() : document.getElementById("close-cart-drawer").click();

    }
});

function saveGender(gender) {
 localStorage.setItem("gender_hidden", gender);
}

//iwish customisations

const iwishMsgBox = document.querySelector('.iwishMsgInfo')
iwishMsgBox.textContent == "" ? iwishMsgBox.innerHTML = "<div class='content--loader' style='margin:0 auto;'></div>" : "";

const iwishATCs = document.getElementsByClassName("iwishBuyBtn");
const iwishSelects = document.getElementsByClassName("product-single__variants");

for (let i = 0; i < iwishATCs.length; i++) {
  iwishATCs[i].addEventListener("click", function (event) {
    event.preventDefault();
    const prodID = event.target.closest('form').getAttribute('variant-id');
    CartJS.addItem(prodID);
    setTimeout(function () {
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true,
        })
      );
      refreshcart();
      document.getElementById("drawerbtn").click();
    }, 1000);
  });
}


Array.from(iwishSelects).forEach((select) => {
  let sizeSelected = false;
  let available = false;

  Array.from(select.options).forEach((option) => {
    if (option.getAttribute("data-stock") === "0") {
      option.disabled = true;
    } else if (!sizeSelected) {
      option.parentElement.value = option.value
      sizeSelected = true;
      available = true;
    } else {
      available = true;
    }
  });

  let thisForm = select.closest('form');
  let currentValue = select.value;
  thisForm.setAttribute('variant-id', currentValue);

    select.addEventListener("change", function (e) {
      thisForm.setAttribute("variant-id", e.target.value);
    });

   if (!available) {
    const buyButton = select.parentElement.nextElementSibling;
    const newElement = document.createElement("div");
    newElement.className = buyButton.className + " BIS_trigger";
    newElement.style.cursor = "default" ;
    newElement.textContent = "OUT OF STOCK";
    buyButton.parentNode.replaceChild(newElement, buyButton);
   }

});

function removeEffect(button) {
  let item = button.closest(".CartItemWrapper");
  item.style.filter = "opacity(0.0)";
}